import * as React from 'react'
import { useEffect, useState } from 'react'

import {AppContext} from "../../../Context/AppContext"

import {postier} from "./Postier"
import { formatZipCode } from './zipcode'

export function Update({setPage}) {

    const {token,client,sites, setSites, setErrors} = React.useContext(AppContext)

    const [isMonitored, setIsMonitored] = React.useState(sites.IsMonitored==1)

    const [WeatherZipCode, setWeatherZipCode] = React.useState(sites.WeatherZipCode)

    const [zipCode, setZipCode] = React.useState("")
    const [siteName, setSiteName] = useState<string>(sites.Name)

    useEffect(() => {
        formatZipCode(sites, setZipCode)
    }, [sites])


    const validate = ()=>{

        const siteInfo = {
            Code:sites.Code,
            ID:sites.ID,
            Country:sites.Country,
            Name:siteName,
            WeatherZipCode:WeatherZipCode,
            ZipCode:zipCode,
            IsMonitored:isMonitored
        }

        setSites(siteInfo)
        postier.updateSite(token,client,siteInfo,setPage, setErrors, client.split(":")[3])

    }

    return (
        <>
            <h2>{sites.Name}</h2>
            <label>ID  </label><div className="label"> {sites.ID}</div>
            <label>Nom du site</label><input className="label" value={siteName} onChange={e=>{setSiteName(e.target.value)}} /> 
            <label>Code  </label><div className="label"> {sites.Code}</div>
            <label>Pays  </label><div className="label"> {sites.Country}</div>
            {/* <label>IsMonitored  </label><input type="checkbox" className="label" defaultChecked={isMonitored} onChange={()=>{setIsMonitored(!isMonitored)}} /> </div> */}
            <label>WeatherZipCode</label><input className="label" value={WeatherZipCode} onChange={e=>{setWeatherZipCode(e.target.value)}} /> 
            <label>ZipCode</label><input className="label" value={zipCode} onChange={e=>{setZipCode(e.target.value)}} />
            <button className="validate" onClick={validate} >Enregistrer</button>
            <button className="validate" onClick={() => setPage("main")}>Retour au menu</button>
        </>
    )
}
